import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    SelectChangeEvent,
    TextField,
} from "@mui/material";
import React, { ChangeEvent, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { OpenLoadingBarThunk } from "../../redux/common/isLoading/thunk";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import { axiosGet } from "../../util/axios";
import {
    ChangeEffectiveDateThunk,
    ChangeRouteNameThunk,
    ChangeRouteRemarkThunk,
    ChangingEndTimeThunk,
    SelectCollectorThunk,
    SelectWorkingDateThunk,
    changeStartingTimeThunk,
    handleDropDownThunk,
    initCollectorListThunk,
    selectedBinInfosThunk,
} from "../../redux/route/thunk";
import { OpenSnackBarWithResultFail } from "../../redux/common/snackBar/thunk";
import { InitBinListAction } from "../../redux/staticInfo/action";
import ReactSelect, { MultiValue } from "react-select";
import { BinInfo } from "../../redux/staticInfo/state";
import styles from "./routeDetail.module.css";
import { Day } from "../../interface/form";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 150,
        },
    },
};

function RouteDetail() {
    const dataFetchedRef = useRef(false);
    const dispatch = useDispatch<IRootThunkDispatch>();
    const {
        collectorList,
        selectedBinInfo,
        route_name,
        collector_id,
        effective_day,
        remark,
        weekday,
    } = useSelector((state: IRootState) => state.routeState);
    const { originalList } = useSelector(
        (state: IRootState) => state.staticInfoState
    );

    useEffect(() => {
        const controller = new AbortController();
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        initFormData();
        return () => {
            controller.abort();
        };
    }, []);

    async function initFormData() {
        dispatch(OpenLoadingBarThunk(true));
        const result = await axiosGet("/api/collection/collector");
        const bin = await axiosGet("/api/bin");
        dispatch(OpenLoadingBarThunk(false));
        if (result.data.success) {
            dispatch(initCollectorListThunk(result.data.collectorList));
        } else {
            dispatch(OpenSnackBarWithResultFail("未能取得收集者名單"));
        }
        if (bin.data.success) {
            dispatch(InitBinListAction(bin.data.binList));
        } else {
            dispatch(OpenSnackBarWithResultFail("未能取得桶名單"));
        }
    }

    function handleSelectedBin(binInfo: MultiValue<BinInfo>) {
        dispatch(selectedBinInfosThunk(binInfo));
    }

    function handleDragStart(
        e: React.DragEvent<HTMLDivElement>,
        index: number
    ) {
        e.dataTransfer.setData("text/plain", index.toString());
    }
    function handleDragOver(e: React.DragEvent<HTMLDivElement>) {
        e.preventDefault();
    }
    function handleDrop(e: React.DragEvent<HTMLDivElement>, index: number) {
        const draggedIndex = Number(e.dataTransfer.getData("text/plain"));
        dispatch(handleDropDownThunk(draggedIndex, selectedBinInfo!, index));
        // dispatch(selectedBinInfosThunk(newSelectedBinInfo))
    }
    function handleRouteNameChange(event: ChangeEvent<HTMLInputElement>) {
        dispatch(ChangeRouteNameThunk(event.target.value));
    }

    function handleCollectorChange(event: SelectChangeEvent<string>) {
        if (!event.target.value) {
            return;
        }
        dispatch(SelectCollectorThunk(event.target.value));
    }

    function handleCheckboxChange(event: ChangeEvent<HTMLInputElement>) {
        
        dispatch(SelectWorkingDateThunk(event.target.value));
    }

    function handleRouteRemark(event: ChangeEvent<HTMLInputElement>) {
        dispatch(ChangeRouteRemarkThunk(event.target.value));
    }

    function handleChangeStartTime(
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        index: number
    ) {
        dispatch(changeStartingTimeThunk(event.target.value, index));
    }

    function handleChangeEndTime(
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        index: number
    ) {
        dispatch(ChangingEndTimeThunk(event.target.value, index));
    }

    function handleEffectiveDateChange(date: Date) {
        console.log('date',date)
        dispatch(ChangeEffectiveDateThunk(date));
    }

    return (
        <Grid>
            <Grid className={styles.formOuterContainer}>
                <Grid className={styles.routeNameAndEffectiveOuterContainer}>
                    <Grid className={styles.routeNAmeContainer}>
                        <InputLabel htmlFor="date-picker">車線名稱*</InputLabel>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            onChange={handleRouteNameChange}
                            value={route_name}
                            fullWidth
                        />
                    </Grid>
              <Grid className={styles.effectivedateContainer}>
                        <InputLabel htmlFor="enquiry-date-picker">
                            生效日期*
                        </InputLabel>
                        <DatePicker
                            onChange={(data) =>
                                handleEffectiveDateChange(data! as Date)
                            }
                            value={effective_day }
                            sx={{ width: "100%" }}
                            format="YYYY-MM-DD"
                        />
                    </Grid>

                </Grid>

                <Grid>
                    <InputLabel id="district-area-id">收集者*</InputLabel>
                    <div>
                        <Select
                            labelId="district-area-id"
                            required
                            id="district-area-id"
                            label="區域"
                            MenuProps={MenuProps}
                            value={collector_id!}
                            onChange={handleCollectorChange}
                            fullWidth
                        >
                            <MenuItem value="">
                                <em>------</em>
                            </MenuItem>
                            {collectorList?.map((list) => (
                                <MenuItem
                                    value={list.user_id}
                                    key={`role-${list.user_id}`}
                                >
                                    {list.username}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                </Grid>

                <Grid>
                    <FormControl>
                        <FormLabel id="demo-row-radio-buttons-group-label">
                            工作日*
                        </FormLabel>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={weekday}
                        >
                            <FormControlLabel
                                value="1"
                                control={
                                    <Radio
                                        onChange={(e) =>
                                            handleCheckboxChange(e)
                                        }
                                    />
                                }
                                label="星期一"
                            />
                            <FormControlLabel
                                value="2"
                                control={
                                    <Radio
                                        onChange={(e) =>
                                            handleCheckboxChange(e)
                                        }
                                    />
                                }
                                label="星期二"
                            />
                            <FormControlLabel
                                value="3"
                                control={
                                    <Radio
                                        onChange={(e) =>
                                            handleCheckboxChange(e)
                                        }
                                    />
                                }
                                label="星期三"
                            />
                            <FormControlLabel
                                value="4"
                                control={
                                    <Radio
                                        onChange={(e) =>
                                            handleCheckboxChange(e)
                                        }
                                    />
                                }
                                label="星期四"
                            />
                            <FormControlLabel
                                value="5"
                                control={
                                    <Radio
                                        onChange={(e) =>
                                            handleCheckboxChange(e)
                                        }
                                    />
                                }
                                label="星期五"
                            />
                            <FormControlLabel
                                value="6"
                                control={
                                    <Radio
                                        onChange={(e) =>
                                            handleCheckboxChange(e)
                                        }
                                    />
                                }
                                label="星期六"
                            />
                            <FormControlLabel
                                value="7"
                                control={
                                    <Radio
                                        onChange={(e) =>
                                            handleCheckboxChange(e)
                                        }
                                    />
                                }
                                label="星期日"
                            />
                        </RadioGroup>
                    </FormControl>
                </Grid>

                <Grid>
                    <Grid>
                        <InputLabel id="district-area-id">
                            桶號及名稱*
                        </InputLabel>
                        <ReactSelect
                            options={originalList}
                            isSearchable
                            menuPlacement="auto"
                            menuPosition="fixed"
                            isMulti
                            value={selectedBinInfo}
                            // isDisabled={isGovernmentRole}
                            onChange={(bin) => handleSelectedBin(bin)}
                        />
                    </Grid>
                </Grid>

                <Grid>
                    <Grid>
                        <InputLabel id="district-area-id">
                            車線次序 （可用drag Drop 調校）
                        </InputLabel>
                    </Grid>

                    <Grid className={styles.routeSequenceContainer}>
                        {selectedBinInfo?.map((bin, index) => (
                            <Grid
                                key={`bin-${bin.value}`}
                                className={styles.routeSequenceInnerContainer}
                                draggable
                                onDragStart={(e) => handleDragStart(e, index)}
                                onDragOver={handleDragOver}
                                onDrop={(e) => handleDrop(e, index)}
                            >
                                <Grid
                                    className={
                                        styles.routeIndexAndNameContainer
                                    }
                                >
                                    <Grid>{index + 1}</Grid>
                                    <Grid>{bin.label}</Grid>
                                </Grid>

                                <Grid>
                                    <TextField
                                        id="outlined-basic"
                                        label="開始時間*"
                                        variant="outlined"
                                        value={bin.time_start}
                                        onChange={(e) =>
                                            handleChangeStartTime(e, index)
                                        }
                                    />
                                    <TextField
                                        id="outlined-basic"
                                        label="完成時間*"
                                        variant="outlined"
                                        value={bin.time_end}
                                        onChange={(e) =>
                                            handleChangeEndTime(e, index)
                                        }
                                    />
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>

                <Grid>
                    <InputLabel id="district-area-id">備註</InputLabel>
                    <TextField
                        id="outlined-multiline-static"
                        multiline
                        rows={4}
                        placeholder="請輸入備註(若有)"
                        fullWidth
                        value={remark}
                        onChange={handleRouteRemark}
                        // disabled={isGovernmentRole}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}

export default RouteDetail;
